import cn from "@/v2-ui/utils/utils.cn"
import Separator from "@/v2-ui/separator"
import type { DateRangeMode } from "./dateRangePicker.types"
import { getDateRangePresets } from "./dateRangePicker.utils"
import { useDateRangePickerContext } from "./dateRangePicker.context"

const MODES: { value: DateRangeMode; label: string }[] = [
  { value: "within", label: "Within" },
  { value: "before", label: "Before" },
  { value: "after", label: "After" },
]

function DateRangePickerSidebar() {
  const { mode, changeMode, applyPreset } = useDateRangePickerContext()
  const presets = getDateRangePresets()

  return (
    <div className="ui-date-picker-sidebar">
      <div className="ui-date-picker-sidebar-section">
        <span className="ui-date-picker-sidebar-label">Mode</span>
        {MODES.map((m) => (
          <button
            key={m.value}
            type="button"
            className={cn(
              "ui-date-picker-sidebar-item",
              mode === m.value && "ui-date-picker-sidebar-item-active",
            )}
            onClick={() => changeMode(m.value)}
          >
            {m.label}
          </button>
        ))}
      </div>

      <Separator className="ui-date-picker-sidebar-separator" />

      <div className="ui-date-picker-sidebar-section">
        <span className="ui-date-picker-sidebar-label">Presets</span>
        {presets.map((preset) => (
          <button
            key={preset.label}
            type="button"
            className="ui-date-picker-sidebar-item"
            onClick={() => {
              applyPreset(preset)
            }}
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default DateRangePickerSidebar
